import { connect } from 'react-redux'
import ProfilePermissionHead from './profile-permission-head'
import { withRouter } from 'react-router'
import {
  getProfile,
  getState
} from '../../../../../../stores/profile/profile.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import {
  addPermissionProfile,
  removePermissionProfile
} from '../../../../../../stores/profile/profile.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match, me }) => {
  const currentState = getState(state)
  const profile = getProfile(state)
  return {
    pending:
      currentState.addingPermission.pending ||
      currentState.removingPermission.pending,
    pupilName: profile.full_name,
    permission: profile.student_type.policy.can_publish,
    canUpdatePermission: me.account.policy.can_update_school_leader_permissions
  }
}

const mapDispatchToProps = (dispatch, { match }) => {
  return {
    addPermission: () =>
      dispatch(addPermissionProfile(match.params.id)).catch(errorHandler),
    removePermission: () =>
      dispatch(removePermissionProfile(match.params.id)).catch(errorHandler)
  }
}

export default withMe(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProfilePermissionHead)
  )
)
